import React from 'react';

export const InputHidden = React.memo((field:any) => {
    return (
        <input type="hidden" {...field.input} />
    );
});
